export const getText = state => key => state.textsReducer.data[key] || '';
